import type { CSSProperties } from 'react';
import { tint } from '../launcher/format';

/** The launcher's per-key tint laid over the surface color, so it reads the same on any backdrop. */
export function solidTint(key: string, strength = 1): CSSProperties {
  const t = tint(key, strength);
  return { background: `linear-gradient(${t}, ${t}), var(--surface)` };
}

/** The hue `tint()` picks for a key (same hash), for drawings that need a solid color in it. */
export function hue(key: string): number {
  let h = 0;
  for (const ch of key) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}
